import React, { createContext, useContext, useState, useEffect } from 'react'
import { verifyToken } from '../utils/auth'

const UserContext = createContext()

export function UserProvider({ children }) {
  const [userData, setUserData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const initializeUser = async () => {
      try {
        const data = await verifyToken()
        setUserData(data)
      } catch (error) {
        console.error('Failed to verify token:', error)
      } finally {
        setIsLoading(false)
      }
    }

    initializeUser()

    const handleUserDataChanged = (event) => {
      setUserData(event.detail)
      setIsLoading(false)
    }

    window.addEventListener('user-data-changed', handleUserDataChanged)
    return () => {
      window.removeEventListener('user-data-changed', handleUserDataChanged)
    }
  }, [])

  return (
    <UserContext.Provider value={{ userData, setUserData, isLoading }}>
      {children}
    </UserContext.Provider>
  )
}

export function useUser() {
  const context = useContext(UserContext)
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider')
  }
  return context
} 